var map = {
	"./arrow-1.svg": "971b",
	"./arrow-down-blue.svg": "c58c",
	"./arrow-down-red.svg": "bedc",
	"./arrow-down.svg": "2e6e",
	"./arrow-point-to-left.svg": "7b4e",
	"./arrow-point-to-right.svg": "0285",
	"./arrow-right.svg": "3f8a",
	"./calendar.svg": "4fef",
	"./cancel.svg": "fd77",
	"./cancel_nobg.svg": "a6cd",
	"./comma.svg": "5d70",
	"./contact-qa-red.svg": "4d3e",
	"./hand.svg": "4819",
	"./icon/MenuSearch.svg": "ac32",
	"./icon/arrow_down_w.svg": "6fd0",
	"./icon/arrow_left_w.svg": "3389",
	"./icon/backtop.svg": "ffb8",
	"./icon/chatroom_send.svg": "b401",
	"./icon/chatroom_upload.svg": "70bb",
	"./icon/check-red.svg": "7c82",
	"./icon/check.svg": "4f4e",
	"./icon/contact-qa.svg": "5ba3",
	"./icon/contact_us.svg": "55bc",
	"./icon/copy-item.svg": "d2c83",
	"./icon/copy-orderNo.svg": "e7fa",
	"./icon/delivery_off.svg": "5787",
	"./icon/delivery_on.svg": "63f6",
	"./icon/fail.svg": "702a",
	"./icon/file.svg": "7294",
	"./icon/filter.svg": "2ee9",
	"./icon/home_off.svg": "a1b9",
	"./icon/home_on.svg": "36af",
	"./icon/ico-banner-arrow-l.svg": "13ee",
	"./icon/ico-banner-arrow-r.svg": "9309",
	"./icon/left_top_arrow.svg": "184b",
	"./icon/pi-point.svg": "16f2",
	"./icon/record_arrow.svg": "64da",
	"./icon/refund.svg": "6b4a",
	"./icon/returnBox.svg": "1bb1",
	"./icon/search_off.svg": "cc46",
	"./icon/search_on.svg": "cf25",
	"./icon/service_off.svg": "952c",
	"./icon/service_on.svg": "f8e1",
	"./icon/simple-circle_gray.svg": "1652",
	"./icon/sort.svg": "8498",
	"./icon/success.svg": "59fb",
	"./icon/ticket_off.svg": "55f1",
	"./icon/ticket_on.svg": "7877",
	"./icon/upload-plus.svg": "5834",
	"./image.svg": "38ea",
	"./loading-red.svg": "3114",
	"./noorder.svg": "3e79",
	"./noproduct.svg": "706a",
	"./order-question-red.svg": "100b",
	"./order-question.svg": "db94",
	"./placholder_1024.svg": "68d2",
	"./placholder_1200.svg": "e760",
	"./placholder_512.svg": "a3f7",
	"./policy-info-gray.svg": "59f4",
	"./question-red.svg": "799d",
	"./question.svg": "5009",
	"./radio-ticked.svg": "09f1",
	"./return/bank_on.svg": "0fdc",
	"./return/docSend_on.svg": "720a",
	"./return/policy_on.svg": "763c",
	"./return/refund_on.svg": "eef5",
	"./return/send-fail.svg": "48c5",
	"./return/send-success.svg": "9436",
	"./select_arrow_down.svg": "11db",
	"./send.svg": "c23e",
	"./service-agent.svg": "67cb",
	"./service-customer.svg": "f70b",
	"./service.svg": "71b4",
	"./speaker.svg": "4d38",
	"./ticket.svg": "6485",
	"./triangle-down.svg": "ab00",
	"./weeklyHot.svg": "57b0",
	"./weeklyHot/rank-1.svg": "48d0",
	"./weeklyHot/rank-2.svg": "888a",
	"./weeklyHot/rank-3.svg": "884a",
	"./weeklyHot/rank-plain.svg": "06d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";